import defaultValues from "@/constant/defaultValues";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { useRef, useState } from "react";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import Select from "react-select";
import {
  ClassicEditor,
  Essentials,
  Bold,
  Italic,
  Underline,
  FontSize,
  Paragraph,
  List,
} from "ckeditor5";
import ReCAPTCHA from "react-google-recaptcha";
import Button from "@/components/Button";
import { useDispatch, useSelector } from "react-redux";
import { selectFormattedCountries } from "@/store/modern/slices/countrySlice";
import errorMessages from "@/constant/errorMessages";
import regExpressions from "@/constant/regExpressions";

import { postInquiryQuote } from "@/store/modern/slices/inquirySlice";
import { showSuccessMessage } from "@/utils/common";
import ScreenLoaderHome from "@/components/common/ScreenLoaderHome";
import { useAuth } from "@/AuthProvider";


const SupplierInqForm = () => {

  const { INDUSTRIES_LIST, EMAIL_FIELD_MAX_LENGTH, IGNORE_EMAILS } = defaultValues;
  const recaptcha = useRef();
  const dispatch = useDispatch();

  const countries = useSelector(selectFormattedCountries);

  const { user } = useAuth();
  
  console.log("user >>>>>>>>>>>>. ", user);

  const inputFields = {
    company_name: user ? user.company_name : "",
    contact_person: user ? user.name : "",
    email: user ? user.email : "",
    phone: "",
    industry: "",
    country: "",
    product: "",
    quantity: "",
    unit: "",
    message: "",
    type: "Supplier",
    inquiry_type: "GLOBAL",
    created_by: user ? user.id : null
  };

  const [formData, setFormData] = useState(inputFields);
  const [errors, setErrors] = useState({});
  const [phoneValue, setphoneValue] = useState("");
  const [selectedIndustry, setSelectedIndustry] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [recaptchaValue, setRecapchaValue] = useState(null);
  const [isButtonDisabled, setisButtonDisabled] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  const handlePhoneChange = (val) => {
    setphoneValue(val);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        phone: val,
      };
    });
  }

  const handleIndustryChange = (val) => {
    setSelectedIndustry(val);
    setFormData((preValue) => {
      return {
        ...preValue,
        industry: val.value
      }
    })
  }

  const handleCountryChange = (val) => {
    setSelectedCountry(val);
    setFormData((preValue) => {
      return {
        ...preValue,
        country: val.value
      }
    });
  }

  const handleRecaptchaChange = (value) => {
    setRecapchaValue(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      recaptcha: value ? "" : "Please complete the reCAPTCHA",
    }));
  }

  const handleFocusOut = (e) => {
    let flag = 0;
    let er = { ...errors };
    if (e.target.name === 'company_name') {
      if (e.target.value === "") {
        flag = 1;
        er.company_name = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > 150) {
        flag = 1;
        er.company_name = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const regExp = regExpressions.company_name;
        const check = regExp.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.company_name = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          flag = 0;
          er.company_name = "";
        }
      }
    }

    if (e.target.name === 'contact_person') {
      if (e.target.value === "") {
        flag = 1;
        er.contact_person = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > 50) {
        flag = 1;
        er.contact_person = errorMessages.MAX_LENGTH_EXCEEDED;
      } else {
        const regExp = regExpressions.name;
        const check = regExp.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.contact_person = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          flag = 0;
          er.contact_person = "";
        }
      }
    }

    if (e.target.name === 'email') {
      if (e.target.value === "") {
        flag = 1;
        er.email = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > EMAIL_FIELD_MAX_LENGTH) {
        flag = 1;
        er.email = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const currentEmail = e.target.value.split("@")[1];
        const regExp = regExpressions.email;
        const check = regExp.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.email = errorMessages.IN_VALID_FIELD_FORMAT;
        } else if (IGNORE_EMAILS.includes(currentEmail)) {
          flag = 1;
          er.email = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          flag = 0;
          er.email = "";
        }
      }
    }


    if (e.target.name === "phone") {
      let phoneValue = e.target.value.trim();
      let numberWithoutCountryCode = phoneValue.replace(/^\+(\d{1,4})\s?/, "").replace(/\s/g, "");
      if (numberWithoutCountryCode === '+') {
        flag = 0;
        er.phone = "";
      }
      if (phoneValue !== '' && phoneValue.length > 4 && numberWithoutCountryCode > 0) {
        if (!isValidPhoneNumber(phoneValue)) {
          flag = 1;
          er.phone = errorMessages.CONTACT_NUMBER_VALIDATION_MSG;
        } else {
          flag = 0;
          er.phone = "";
        }
      }
    }

    if (e.target.name === 'industry') {
      if (e.target.value === '') {
        flag = 1;
        er.industry = errorMessages.FIELD_REQUIRED;
      } else {
        flag = 0;
        er.industry = "";
      }
    }

    if (e.target.name === 'country') {
      if (e.target.value === '') {
        flag = 1;
        er.country = errorMessages.FIELD_REQUIRED;
      } else {
        flag = 0;
        er.country = "";
      }
    }


    if (e.target.name === 'product') {
      if (e.target.value === "") {
        flag = 1;
        er.product = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > 40) {
        flag = 1;
        er.product = errorMessages.MAX_LENGTH_EXCEEDED;
      } else {
        const regExp = regExpressions.inquiry.product;

        const check = regExp.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.product = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          flag = 0;
          er.product = "";
        }
      }

    }

    if (e.target.name === 'quantity') {
      let quantity = e.target.value;
      let quantityReg = regExpressions.inquiry.quantity;
      if (e.target.value !== '' && quantity.length > 0) {
        if (quantity.length > 20) {
          flag = 1;
          er.quantity = errorMessages.MAX_LENGTH_20_EXCEEDED;
        } else {
          const check = quantityReg.test(e.target.value);
          if (check === false) {
            flag = 1;
            er.quantity = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            flag = 0;
            er.quantity = '';
          }
        }
      }
    }

    if (e.target.name === 'unit') {
      let unit = e.target.value;
      let untiEpr = regExpressions.inquiry.unit;
      if (e.target.value !== '' && unit.length > 0) {
        if (unit.length > 20) {
          flag = 1;
          er.unit = errorMessages.MAX_LENGTH_20_EXCEEDED;
        } else {
          const check = untiEpr.test(e.target.value);
          if (check === false) {
            flag = 1;
            er.unit = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            flag = 0;
            er.unit = '';
          }
        }
      }
    }

    setErrors(er);
    if (flag === 0) {
      setisButtonDisabled(false);
      return false;
    } else {

      return true;
    }
  }

  const handleChange = (e) => {
    setFormData((prevalue) => {
      return {
        ...prevalue,
        [e.target.name]: e.target.value
      }
    })
  }

  const validation = () => {

    let er = { ...errors };
    let isValid = true;

    if (!formData.company_name || formData.company_name === "") {
      isValid = false;
      er.company_name = errorMessages.FIELD_REQUIRED;
    } else if (formData.company_name.length > 150) {
      isValid = false;
      er.company_name = errorMessages.MAX_LENGTH_150_EXCEEDED;
    } else {
      const regExp = regExpressions.company_name;
      const check = regExp.test(formData.company_name);
      if (check === false) {
        isValid = false;
        er.company_name = errorMessages.IN_VALID_FIELD_FORMAT;
      } else {
        er.company_name = "";
      }
    }


    if (formData.contact_person === "") {
      isValid = false;
      er.contact_person = errorMessages.FIELD_REQUIRED;
    } else if (formData.contact_person.length > 50) {
      isValid = false;
      er.contact_person = errorMessages.MAX_LENGTH_50_EXCEEDED;
    } else {
      const regExp = regExpressions.name;

      const check = regExp.test(formData.contact_person);
      if (check === false) {
        isValid = false;
        er.contact_person = errorMessages.IN_VALID_FIELD_FORMAT;
      } else {
        er.contact_person = "";
      }
    }

    if (formData.email === "") {
      isValid = false;
      er.email = errorMessages.FIELD_REQUIRED;
    } else if (formData.email.length > EMAIL_FIELD_MAX_LENGTH) {
      isValid = false;
      er.email = errorMessages.MAX_LENGTH_150_EXCEEDED;
    } else {
      const currentEmail = formData.email.split("@")[1];
      const regExp = regExpressions.email;
      const check = regExp.test(formData.email);
      if (check === false) {
        isValid = false;
        er.email = errorMessages.IN_VALID_FIELD_FORMAT;
      } else if (IGNORE_EMAILS.includes(currentEmail)) {
        isValid = false;
        er.email = errorMessages.IN_VALID_FIELD_FORMAT;
      } else {
        er.email = "";
      }
    }


    if (phoneValue) {
      let numberWithoutCountryCode = phoneValue.replace(/^\+(\d{1,4})\s?/, '');
      numberWithoutCountryCode = numberWithoutCountryCode.replace(/\s/g, '');
      if (!phoneValue || !isValidPhoneNumber(phoneValue) && numberWithoutCountryCode.length > 0) {
        isValid = false;
        er.phone = errorMessages.CONTACT_NUMBER_VALIDATION_MSG;
      }
    }

    if (formData.industry === '') {
      isValid = false;
      er.industry = errorMessages.FIELD_REQUIRED;
    } else {
      er.industry = "";
    }

    if (formData.country === '') {
      isValid = false;
      er.country = errorMessages.FIELD_REQUIRED;
    } else {
      er.country = "";
    }


    if (formData.product === "") {
      isValid = false;
      er.product = errorMessages.FIELD_REQUIRED;
    } else if (formData.product.length > 40) {
      isValid = false;
      er.product = errorMessages.MAX_LENGTH_EXCEEDED;
    } else {
      const regExp = regExpressions.inquiry.product;

      const check = regExp.test(formData.product);
      if (check === false) {
        isValid = false;
        er.product = errorMessages.IN_VALID_FIELD_FORMAT;
      } else {
        er.product = "";
      }
    }



    let quantity = formData.quantity;
    let quantityReg = regExpressions.inquiry.quantity;
    if (quantity !== '' && quantity.length > 0) {
      if (quantity.length > 20) {
        isValid = false;
        er.quantity = errorMessages.MAX_LENGTH_20_EXCEEDED;
      } else {
        const check = quantityReg.test(quantity);
        if (check === false) {
          isValid = false;
          er.quantity = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          er.quantity = '';
        }
      }
    }

    let unit = formData.unit;
    let untiEpr = regExpressions.inquiry.unit;
    if (unit !== '' && unit.length > 0) {
      if (unit.length > 20) {
        isValid = false;
        er.unit = errorMessages.MAX_LENGTH_20_EXCEEDED;
      } else {
        const check = untiEpr.test(unit);
        if (check === false) {
          isValid = false;
          er.unit = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          er.unit = '';
        }
      }
    }

    if (recaptchaValue === null) {
      isValid = false;
      er.recaptcha = "Please verify the reCAPTCHA!";
    } else {
      er.recaptcha = "";
    }
    setErrors(er);

    if (!isValid) {
      return false;
    }
    return true;

  }

  const handleSubmit = async (e) => {
    console.log("handle Submit is called.", formData);
    e.preventDefault();
    if (validation()) {
      try {
        setisButtonDisabled(true);
        setLoading(true);
        const response = await dispatch(postInquiryQuote(formData));
        if (response && response.meta.requestStatus === "fulfilled") {

          if (response.payload.status === true) {
            setisButtonDisabled(false);
            showSuccessMessage("The inquiry has been submitted successfully.");
            setFormData({
              company_name: user ? user.company_name : "",
              contact_person: user ? user.name : "",
              email: user ? user.email : "",
              phone: "",
              industry: "",
              country: "",
              product: "",
              quantity: "",
              unit: "",
              message: "",
              type: "Supplier",
              inquiry_type: "GLOBAL",
              created_by: user ? user.id : null
            });
            setErrors({});
            setphoneValue("");
            setSelectedIndustry(null);
            setSelectedCountry(null);
            setTimeout(() => {
              recaptcha.current.reset();
              // setMessage("");
              setLoading(false);
            }, 3000);

            setRecapchaValue(null);
          }

          if (response.payload.errors) {
            setisButtonDisabled(false);
            setLoading(false);
            setErrors([]);
            const errors = {};
            if (response.payload.errors.company_name) {
              errors.company_name = response.payload.errors.company_name;
            }
            if (response.payload.errors.contact_person) {
              errors.contact_person = response.payload.errors.contact_person;
            }
            if (response.payload.errors.email) {
              errors.email = response.payload.errors.email;
            }
            if (response.payload.errors.country) {
              errors.country = response.payload.errors.country;
            }
            if (response.payload.errors.industry) {
              errors.industry = response.payload.errors.industry;
            }
            if (response.payload.errors.product) {
              errors.product = response.payload.errors.product;
            }
            if (response.payload.errors.quantity) {
              errors.quantity = response.payload.errors.quantity[0];
            }
            if (response.payload.errors.unit) {
              errors.unit = response.payload.errors.unit;
            }
            setErrors(errors);
          }

        }
      } catch (err) {
        console.log("Error =========== ", err);
      }
    }
  }

  const styleError = { display: 'block' };

  return (<>
    {isLoading && <ScreenLoaderHome />}
    <section className="form-wrape">
      <div className="section-head">
        <h1>Submit Your Requirement</h1>
        <p>Easily submit your product or service requirements and connect with verified suppliers worldwide.</p>
      </div>
      <div className="form-pad">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-sm-12 mb-3 inquiry-info-labal">
              <h2 className="head ">Contact Information</h2>
            </div>

            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div className={`input-wrape ${errors.company_name ? 'error-show' : ''}`}>
                <div className="input-pad">
                  <input
                    type="text"
                    name="company_name"
                    value={formData.company_name}
                    className="input"
                    autoComplete="off"
                    placeholder="Enter company name *"
                    onChange={handleChange}
                    onBlur={handleFocusOut}
                    disabled={user && user.company_name}

                  />
                  {errors.company_name && (
                    <span
                      className="invalid-feedback"
                      style={styleError}
                    >
                      {errors.company_name}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div className={`input-wrape ${errors.contact_person ? 'error-show' : ''}`}>
                <div className="input-pad">
                  <input
                    type="text"
                    name="contact_person"
                    value={formData.contact_person}
                    className="input"
                    autoComplete="off"
                    placeholder="Enter contact person *"
                    onChange={handleChange}
                    onBlur={handleFocusOut}
                    disabled={user && user.name}
                  />
                  {errors.contact_person && (
                    <span
                      className="invalid-feedback"
                      style={styleError}
                    >
                      {errors.contact_person}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div className={`input-wrape ${errors.email ? 'error-show' : ''}`}>
                <div className="input-pad ">
                  <input
                    type="text"
                    name="email"
                    className="input"
                    value={formData.email}
                    autoComplete="off"
                    placeholder="Enter your email *"
                    onChange={handleChange}
                    onBlur={handleFocusOut}
                    disabled={user && user.email}
                  />
                  {errors.email && (
                    <span
                      className="invalid-feedback"
                      style={styleError}
                    >
                      {errors.email}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div className={`input-wrape ${errors.phone ? 'error-show' : ''}`}>
                <div className="input-pad">
                  <PhoneInput
                    id="contact-form-phone"
                    className="input"
                    name="phone"
                    international
                    limitMaxLength
                    placeholder="Enter phone number"
                    autoComplete="off"
                    value={phoneValue}
                    onChange={handlePhoneChange}
                    onBlur={handleFocusOut}

                  />
                  {errors.phone && (
                    <span
                      className="invalid-feedback"
                      style={styleError}
                    >
                      {errors.phone}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="col-sm-12 mb-3 inquiry-info-labal">
              <h2 className="head">Inquiry Information</h2>
            </div>

            <div className="col-xxl-12">
              <div id="suppliers" className="row">
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                  <div className={`input-wrape select-wrape ${errors.industry ? 'error-show' : ''}`}>
                    <div className="input-pad select-wrape" >
                      <Select
                        name="industry"
                        options={INDUSTRIES_LIST}
                        value={selectedIndustry}
                        onChange={handleIndustryChange}
                        placeholder="Select industry *"
                        className="select"
                        classNamePrefix={"Drop-down-menu"}
                        noOptionsMessage={() => "No Industry Found"}
                        onBlur={handleFocusOut}
                      />
                      {errors.industry && (
                        <span
                          className="invalid-feedback"
                          style={styleError}
                        >
                          {errors.industry}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                  <div className={`input-wrape select-wrape ${errors.country ? 'error-show' : ''}`}>
                    <div className="input-pad select-wrape">
                      <Select
                        name="country"
                        options={countries}
                        value={selectedCountry}
                        onChange={handleCountryChange}
                        placeholder="Select country *"
                        className="select"
                        classNamePrefix={"Drop-down-menu"}
                        noOptionsMessage={() => "No Country Found"}
                        onBlur={handleFocusOut}
                      />
                      {errors.country && (
                        <span
                          className="invalid-feedback"
                          style={styleError}
                        >
                          {errors.country}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                  <div className={`input-wrape ${errors.product ? 'error-show' : ''}`}>
                    <div className="input-pad">
                      <input
                        type="text"
                        name="product"
                        value={formData.product}
                        className="input"
                        autoComplete="off"
                        placeholder="Enter product *"
                        onChange={handleChange}
                        onBlur={handleFocusOut}
                      />
                      {errors.product && (
                        <span
                          className="invalid-feedback"
                          style={styleError}
                        >
                          {errors.product}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6">
                  <div className={`input-wrape ${errors.quantity ? 'error-show' : ''}`}>
                    <div className="input-pad"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.4}
                      variants={fadeUpVariant}
                    >
                      <input
                        type="text"
                        name="quantity"
                        value={formData.quantity}
                        className="input"
                        autoComplete="off"
                        placeholder="Enter quantity"
                        onChange={handleChange}
                        onBlur={handleFocusOut}
                      />
                      {errors.quantity && (
                        <span
                          className="invalid-feedback"
                          style={styleError}
                        >
                          {errors.quantity}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6">
                  <div className={`input-wrape ${errors.unit ? 'error-show' : ''}`}>
                    <div className="input-pad ">
                      <input
                        type="text"
                        name="unit"
                        value={formData.unit}
                        className="input"
                        autoComplete="off"
                        placeholder="Enter unit"
                        onChange={handleChange}
                        onBlur={handleFocusOut}
                      />
                      {errors.unit && (
                        <span
                          className="invalid-feedback"
                          style={styleError}
                        >
                          {errors.unit}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div className="col-xxl-12">
              <div className={`input-wrape ${errors.message ? 'error-show' : ''}`}>
                <div className="input-pad inquiry-ck-editer">
                  <CKEditor
                    editor={ClassicEditor}
                    data={formData.message || ''}
                    config={{
                      toolbar: {
                        items: ['bold', 'italic', 'underline', 'fontSize', 'bulletedList'],
                      },
                      fontSize: {
                        options: [10, 12, 14, 'default', 18, 20, 22, 24, 30],
                        supportAllValues: false,
                      },
                      language: 'en',
                      plugins: [
                        Essentials,
                        Bold,
                        Italic,
                        Underline,
                        FontSize,
                        Paragraph,
                        List,
                      ],
                      licenseKey: "GPL",
                      // licenseKey: "",

                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setFormData(prev => ({
                        ...prev,
                        message: data,
                      }));
                    }}
                    onReady={(editor) => {
                      editor.editing.view.change((writer) => {
                        writer.setStyle(
                          "height",
                          "150px",
                          editor.editing.view.document.getRoot()
                        );
                        writer.setStyle(
                          "width",
                          "100",
                          editor.editing.view.document.getRoot()
                        );
                      });
                    }}
                  />
                  {errors.message && (
                    <span
                      className="invalid-feedback"
                      style={styleError}
                    >
                      {errors.message}
                    </span>
                  )}
                </div>
              </div>
            </div>


            <div className="col-xxl-8 col-xl-7 col-lg-8 col-md-12">
              <div className="captcha-wrapes">
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_SITE_KEY}
                  onChange={handleRecaptchaChange}
                  ref={recaptcha}
                  className="Inquiry-capcha"
                  onExpired={() => {
                    setRecapchaValue(null);
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      recaptcha: "Please complete the reCAPTCHA",
                    }));
                  }}

                />
                {errors.recaptcha && (
                  <div
                    className="invalid-feedback"
                    style={styleError}
                  >
                    {errors.recaptcha}
                  </div>
                )}
              </div>
            </div>
            <div className="col-xxl-4 col-xl-5 col-lg-4 col-md-12 inquiry-form-btn">
              <Button
                className="btn secondry-btn"
                type="submit"
                disabled={isButtonDisabled}
              >
                Send Inquiry
              </Button>
            </div>
          </div>
        </form>
      </div>
    </section>
  </>)
}

export default SupplierInqForm;

